import React from 'react';
import Slider from 'react-slick';
import ClientCarouselCard from './ClientCarouselCard';
import './Clientcarousel.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function ClientCarousel({ ClientContentData }) {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: false,
    slidesPerRow: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          rows: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          rows: 1,
        },
      },
    ],
  };

  const rowsData = ClientContentData.reduce(function (rows, key, index) {
    console.log(rows, key, index, rows[rows.length - 1]);
    return (
      (index % 2 === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) &&
      rows
    );
  }, []);
  console.log(rowsData);

  return (
    <>
      <div className="main-carousel">
        <div className="SlideContent-client">
          {
            <Slider
              {...settings}
              customPaging={(i) => {
                return (
                  <div>
                    <p></p>
                  </div>
                );
              }}
              dotsClass="client-dots client-custom"
            >
              {rowsData.map((data) => (
                <ClientCarouselCard data={data} key={data[0].id} />
              ))}
            </Slider>
          }
        </div>
      </div>
    </>
  );
}
